import(/* webpackMode: "eager" */ "/app/assets/images/Blog_post_creation_1.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Blog_post_creation_2.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Circular-Xylo.png");
import(/* webpackMode: "eager" */ "/app/assets/images/Custom_copy_1.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Custom_copy_2.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Header_services.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Marketing_campaigns_1.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Marketing-campaigns_2.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/product_description_1.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/product_description_2.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Social_media_marketing_1.webp");
import(/* webpackMode: "eager" */ "/app/assets/images/Social_media_marketing_2.webp");
import(/* webpackMode: "eager" */ "/app/assets/svg/Logo_Xylo_texte_circulaire.svg");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js")